var pcs =
    [
        {
            _id: 0, name: 'Zakzakiel', pcClass: 'Rogue', race: 'Aasimar', lvl: '3', url: 'https://i.pinimg.com/474x/de/8f/25/de8f25f927bf76bf8954fc31677268f9--pathfinder-rogue-character-art.jpg',
            factions: [
                { name: 'Tourquennois', rank: 'guard' },
                { name: 'Roubaisien', rank: 'woodworker' },
            ],
            magicitems: [
                { mid: 0, name: 'Cloak of Displacement', notes: "C'est cheat mdr" },
                { mid: 1, name: 'Staff of Defense', notes: "Action bonus" },
                { mid: 2, name: 'Goggle of Nights', notes: "Gogole mdr" }
            ],
            storyAwards: [
                { title: 'Anime fan', notes: 'You have disadvantage on charisma check when in front of girls' },
                { title: 'Carpenter', notes: 'John freaks you out' },
            ],
            consumables: [
                { name: 'Potion of healing', qty: 12 },
                { name: 'Potion of Hiilo', qty: 69 },
                { name: 'Scroll of True Strike', qty: 2 },
            ], setting: 'la guilde cc'
        },
        {
            _id: 1, name: 'Bekirt', pcClass: 'Wizard', race: 'Gnome', lvl: '5', url: 'https://i.redd.it/sb0eqq1v5ap21.png',
            factions: [
                { name: 'Montois', rank: 'pilot' },
                { name: 'Capsylvains', rank: 'bard' },
            ],
            magicitems: [
                {
                    name: 'Southern Pike of the Snake', notes: `Weapon (Pike), uncommon (requires attunement)

                The bearer gains +1 to dexterity saving throws.
                
                The bearer may choose to deal Poison damage with this weapon and gain a +1 bonus to damage.` },
                { name: 'Favored Boots of Forgiveness', notes: `Wonderous item, uncommon (requires attunement), uncommon (requires attunement)

                Once per day, the bearer may roll a saving throw with advantage.
                
                When on the plane of Mount Celestia, the bearer of this item can receive the benefits of Blessed Beneficence regardless of their alignment.` },
                { name: 'Cloy Mask of Gehenna', notes: `Wonderous item, uncommon (requires attunement), uncommon (requires attunement)

                The bearer may cast Friends once per day.
                
                When on the plane of Gehenna, the bearer has advantage on saving throws against Cruel Hindrance. (DMG p. 63)` }
            ],
            storyAwards: [
                { title: 'Anime fan', notes: 'You have disadvantage on charisma check when in front of girls' },
                { title: 'Carpenter', notes: 'John freaks you out' },
            ],
            consumables: [
                { name: 'Potion of Owls Wake', qty: 12 },
                { name: 'Potion of Hiilo', qty: 69 },
                { name: 'Scroll of True Strike', qty: 2 },
            ]
        },
        {
            _id: 2, name: 'Weshin', pcClass: 'Fighter', race: 'Dwarf', lvl: '12', url: 'https://i.pinimg.com/originals/85/68/76/856876db165fd23dae1abe0fe36ec949.jpg',
            factions: [
                { name: 'Tourquennois', rank: 'guard' },
            ],
            magicitems: [
                { name: 'Cloak of Displacement', notes: "C'est cheat mdr" },
            ],
            storyAwards: [
                { title: 'Anime fan', notes: 'You have disadvantage on charisma check when in front of girls' },
            ],
            consumables: [
                { name: 'Potion of healing', qty: 12 },
            ]
        },
        {
            _id: 3, name: 'Emerson', pcClass: 'Ranger', race: 'Half-Elf', lvl: '8', url: 'https://i.pinimg.com/originals/ac/a0/04/aca00424a7de99a1079416bf948fe79b.jpg',
            factions: [
                { name: 'Tourquennois', rank: 'guard' },
            ],
            magicitems: [
                { name: 'Cloak of Displacement', notes: "C'est cheat mdr" },
            ],
            storyAwards: [
                { title: 'Anime fan', notes: 'You have disadvantage on charisma check when in front of girls' },
            ],
            consumables: [
                { name: 'Potion of healing', qty: 12 },
            ]
        },
        {
            _id: 4, name: 'Ghamobal', pcClass: 'Druid', race: 'Human', lvl: '15', url: 'https://i.pinimg.com/originals/b7/37/20/b737209452ba61952cf84fac8fc731d6.png',
            factions: [
                { name: 'Tourquennois', rank: 'guard' },
            ],
            magicitems: [
                { name: 'Cloak of Displacement', notes: "C'est cheat mdr" },
            ],
            storyAwards: [
                { title: 'Anime fan', notes: 'You have disadvantage on charisma check when in front of girls' },
            ],
            consumables: [
                { name: 'Potion of healing', qty: 12 },
            ]
        },
    ]

export default pcs;